var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1027,
    height: 1027,
    viewBox: "0 0 1027 1027",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M940.257 855.833H86.743L513.5 84.1651L940.257 855.833ZM159.309 813.042H867.691L513.5 172.585L159.309 813.042ZM551.537 732.213C551.537 753.017 534.301 770.25 513.5 770.25C492.102 770.25 475.463 753.611 475.463 732.213C475.463 710.818 492.102 694.176 513.5 694.176C534.301 694.176 551.537 711.412 551.537 732.213ZM486.159 475.463V342.333H540.838V475.463L526.575 639.499H500.425L486.159 475.463Z",
    fill: "#CAAA1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.5590d11e55965ce8c7c5a0cc88142339.svg";
export { ForwardRef as ReactComponent };